document.addEventListener("DOMContentLoaded", () => {

    const button = document.querySelector(".redirection-container .read-more");
    const wrapper = document.querySelector(".redirection_links-wrapper");

    if (!button || !wrapper) return;
    const mq = window.matchMedia("(max-width: 998px)"); // Media query for mobile version only

    let expanded = false; // Track whether the content is expanded or collapsed

    if (!mq.matches) return;

    wrapper.style.maxHeight = "50px"; // Set initial collapsed height for mobile
    button.textContent = "Read more";

    button.addEventListener("click", () => {

        if (expanded) {
            // COLLAPSE: limit height and update button text
            wrapper.style.maxHeight = "50px";
            button.textContent = "Read more";
        } else {
            // EXPAND: set height based on full content and update button text
            wrapper.style.maxHeight = wrapper.scrollHeight + "px";
            button.textContent = "Read less";
        }

        expanded = !expanded; // Flip the expanded state
    });
});